import GiftIcon from "./GiftIcon"
import { useState } from "react"

export default function ItemImage({
  src,
  faded = false,
  size = "form",
}: {
  src?: string | null
  faded?: boolean
  size?: "form" | "card"
}) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const showImage = src && src !== failedSrc

  return (
    <div
      data-testid="item-image"
      className={`${size === "card" ? "w-24 h-24" : "w-14 h-14"} shrink-0 rounded-lg bg-gray-100 overflow-hidden flex items-center justify-center text-gray-400 ${
        faded ? "opacity-40 grayscale" : ""
      }`}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={() => setFailedSrc(src)}
          className="w-full h-full object-contain"
        />
      ) : (
        <GiftIcon />
      )}
    </div>
  )
}
